import * as yup from 'yup'

const schema = yup.object().shape({
  questionCode: yup.string().required('Código da questão é obrigatório'),
  auditorAlternativeId: yup
    .number()
    .nullable()
    .required('Alternativa do auditor é obrigatória'),
  unitAlternativeId: yup
    .number()
    .nullable()
    .required('Alternativa da unidade é obrigatória'),
  reportText: yup
    .string()
    .required('Texto do relatório do auditor é obrigatório'),
})

export default schema
